import { takeLatest, call, put, select } from 'redux-saga/effects';
import { serializeParams } from 'utils/functions/general';
import membersActionTypes from './action-types';
import { getMembers, blockMember, awardPoints, deductPoints, getMemberTransactions } from './api';
import {
  fetchMembersSuccess,
  fetchMembersFail,
  fetchMemberSuccess,
  fetchMemberFail,
  updateUserBlockStatusSuccess,
  updateUserBlockStatusFail,
  fetchMemberTransactionsSuccess,
  fetchMemberTransactionsFail,
  updateUserPointsSuccess,
  updateUserPointsFail,
  fetchMemberTransactions,
  addUserSuccess,
  addUserFail,
} from './actions';
import membersStrings from './strings';

function* setfetchMembersSaga({ payload }) {
  try {
    const queryStringOfObj = serializeParams(payload);
    const response = yield call(getMembers, queryStringOfObj);
    yield put(fetchMembersSuccess(response.data));
  } catch (error) {
    console.log(error);
    yield put(fetchMembersFail(error));
  }
}

function* fetchMemberSaga({ payload }) {
  try {
    const queryStringOfObj = serializeParams(payload);
    const response = yield call(getMembers, queryStringOfObj);
    if (response.data.data.length === 0) {
      window.location.href = '/404';
    }
    const memberObj = response?.data?.data?.length !== 0 ? response?.data?.data[0] : {};
    yield put(fetchMemberSuccess({ ...response.data, data: memberObj }));
  } catch (error) {
    console.log(error);
    yield put(fetchMemberFail(error));
  }
}

function* updateUserBlockStatusSaga({ payload }) {
  try {
    const getMember = state => state.members.member;
    const member = yield select(getMember);
    const { userEmail } = member.details.data;
    const { blockSucessMessage, unblockSucessMessage } = membersStrings.memberProfile;

    const queryStringOfObj = serializeParams(payload);
    let confirmationMessage;
    if (payload.blockUser) {
      confirmationMessage = blockSucessMessage(userEmail);
    } else {
      confirmationMessage = unblockSucessMessage(userEmail);
    }
    yield call(blockMember, queryStringOfObj);
    yield put(updateUserBlockStatusSuccess({ isBlocked: payload.blockUser, confirmationMessage }));
  } catch (error) {
    console.log(error);
    yield put(updateUserBlockStatusFail(error));
  }
}

function* fetchMemberTransactionsSaga({ payload }) {
  try {
    const response = yield call(getMemberTransactions, payload);
    yield put(
      fetchMemberTransactionsSuccess({
        ...response.data,
        transactionType: payload.transactionType,
      }),
    );
  } catch (error) {
    console.log(error);
    yield put(fetchMemberTransactionsFail(error));
  }
}

function* updateUserPointsSaga({ payload }) {
  try {
    const { awardSuccessMessage, deductSuccessMessage } = membersStrings.memberProfile;
    const { data, shouldAward, toAddNewMember = false } = payload;
    let updatePoints;
    let confirmationMessage;
    if (toAddNewMember) {
      const { email, amount } = data;
      updatePoints = awardPoints;
      confirmationMessage = awardSuccessMessage(data.amount, email);
      const response = yield call(updatePoints, data);
      if (response.data.success) yield put(addUserSuccess({ amount, confirmationMessage }));
      else yield put(addUserFail());
    } else {
      const getMember = state => state.members.member;
      const member = yield select(getMember);
      let { awardedPoints } = member.details.data;
      const { userEmail } = member.details.data;
      if (shouldAward) {
        updatePoints = awardPoints;
        awardedPoints += data.amount;
        confirmationMessage = awardSuccessMessage(data.amount, userEmail);
      } else {
        updatePoints = deductPoints;
        awardedPoints -= data.amount;
        confirmationMessage = deductSuccessMessage(data.amount, userEmail);
      }
      awardedPoints = awardedPoints > 0 ? awardedPoints : 0;
      yield call(updatePoints, data);
      yield put(updateUserPointsSuccess({ awardedPoints, confirmationMessage }));
      yield put(fetchMemberTransactions({ email: userEmail }));
    }
  } catch (error) {
    console.log(error);
    if (payload.toAddNewMember) yield put(addUserFail(error));
    yield put(updateUserPointsFail(error));
  }
}

function* membersSaga() {
  yield takeLatest(membersActionTypes.FETCH_MEMBERS, setfetchMembersSaga);
  yield takeLatest(membersActionTypes.FETCH_MEMBER, fetchMemberSaga);
  yield takeLatest(membersActionTypes.UPDATE_USER_BLOCK_STATUS, updateUserBlockStatusSaga);
  yield takeLatest(membersActionTypes.FETCH_MEMBER_TRANSACTIONS, fetchMemberTransactionsSaga);
  yield takeLatest(membersActionTypes.UPDATE_USER_POINTS, updateUserPointsSaga);
}

export default membersSaga;
